import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import './CreateFeedback.css';
import Notification from '../../components/Notification/Notification';
import { Link, useNavigate } from 'react-router-dom';

const CreateFeedback = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [notification, setNotification] = useState({ type: '', message: '' });

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const userId = localStorage.getItem('userId');

    const navigate = useNavigate();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageFile(file);
        setPreviewUrl(URL.createObjectURL(file)); // Show preview
    };

    const uploadImageToS3 = async () => {
        if (!imageFile) return '';

        try {
            const response = await privateAxios.get('/private/generate-upload-url', {
                params: {
                    filename: imageFile.name,
                    filetype: imageFile.type,
                },
            });

            const { url } = response.data;

            await publicAxios.put(url, imageFile);

            const uploadedUrl = url.split('?')[0]; // S3 public URL
            return uploadedUrl;
        } catch (error) {
            console.error('Image upload failed:', error);
            throw new Error('Failed to upload image.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setStatus('');

        let uploadedImageUrl = '';

        try {
            // Step 1: Upload image if provided
            if (imageFile) {
                uploadedImageUrl = await uploadImageToS3();
            }

            // Step 2: Create feedback
            const feedbackData = {
                title,
                content,
                imageUrl: uploadedImageUrl || '',
            };

            await privateAxios.post(`/private/create-feedback/${userId}`, feedbackData);

            setStatus('Feedback posted successfully!');
            showNotification('success', 'Feedback sent successfully!');
            setTitle('');
            setContent('');
            setImageFile(null);
            setPreviewUrl('');
            setTimeout(() => {
                navigate('/')
            }, 3000);
        } catch (error) {
            console.error(error);
            showNotification('error', error.message || 'Error sending feedback.');
            setStatus('Error sending feedback.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="create-feedback-container">
            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />
            <Link to={'/'} className='create-feedback-back-to-home-page'>Back to Home</Link>

            <h2>Create Feedback</h2>

            <form onSubmit={handleSubmit}>
                <label>Title:</label>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                <label>Content:</label>
                <ReactQuill value={content} onChange={setContent} theme="snow" />


                <label>Upload Image (optional):</label>
                <input type="file" accept="image/*" onChange={handleImageChange} />
                {previewUrl && (
                    <div className="uploaded-image-preview">
                        <img src={previewUrl} alt="Selected preview" />
                    </div>
                )}

                <button type="submit" disabled={loading}>
                    {loading ? 'Creating Feedback...' : 'Post Feedback'}
                </button>
            </form>

            {status && <p className="status-message">{status}</p>}
        </div>
    );
};

export default CreateFeedback;